import { useEffect, useState } from "react";
import client from "@/lib/api";
import Seo from "@/components/Seo";
import Ticker from "@/components/Ticker";
import DropCard from "@/components/DropCard";
import { FadeUp } from "@/components/Reveal";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "READY", label: "Ready Now" },
  { key: "SOON", label: "Dropping Soon" },
  { key: "SOLD_OUT", label: "Sold Out" },
];

export default function Drops() {
  const [drops, setDrops] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    client
      .get("/drops", { params: filter === "all" ? {} : { status: filter } })
      .then(({ data }) => setDrops(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [filter]);

  return (
    <>
      <Seo title="Drops — YAZA EXOTICS" description="Current and upcoming YAZA exotic drops. Tap in to reserve." />

      <section className="mx-auto max-w-[1600px] px-5 pt-16 pb-8 md:px-10 md:pt-24">
        <FadeUp>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.3em] text-yaza-accent">The Drops</p>
          <h1 className="font-display text-6xl leading-none md:text-8xl">CURRENT & UPCOMING</h1>
        </FadeUp>
      </section>

      <Ticker text="DROPS" speed={60} />

      <section className="mx-auto max-w-[1600px] px-5 py-12 md:px-10 md:py-16">
        <div className="mb-10 flex flex-wrap gap-3" data-testid="drop-filters">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              onClick={() => setFilter(f.key)}
              data-testid={`filter-${f.key}`}
              className={`rounded-none border px-5 py-2 text-xs font-semibold uppercase tracking-widest transition-colors ${
                filter === f.key
                  ? "border-yaza-accent bg-yaza-accent text-black"
                  : "border-yaza-border text-white hover:border-yaza-accent"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {loading ? (
          <p className="text-yaza-dim">Loading drops…</p>
        ) : drops.length === 0 ? (
          <p className="text-yaza-dim" data-testid="no-drops">No drops in this category right now.</p>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {drops.map((d, i) => (
              <DropCard key={d.id} drop={d} index={i} />
            ))}
          </div>
        )}
      </section>
    </>
  );
}
